<template>
<b-container fluid>
 <div class="password-reset-container">
    <a class="logo">
            <div class="logo-f360">
                <img alt="Logo Finanças 360" :src="require('@/assets/logo.png')">
            </div>
    </a>
    <b-form v-show="loginShow" class="text-left form-login">
                            <b-form-row class="px-5">
                                <div class="col-md-12">
                                    <b-form-group
                                        label-size="sm"
                                        label="Nova Senha:"
                                        label-for=""
                                    >
                                        <b-form-input
                                        id="email"
                                        type="password"
                                        v-model="form.password"
                                        required
                                        placeholder="Nova Senha"
                                        size="lg" />
                                    </b-form-group>

                                    <b-form-group
                                        label-size="sm"
                                        label="Repetir Nova Senha"
                                        label-for="Repetir Nova Senha:"
                                        class="position-relative"
                                    >
                                        <b-form-input
                                        id="senha"
                                        type="password"
                                        v-model="form.passwordConfirmation"
                                        required
                                        placeholder="Repetir Nova Senha"
                                        size="lg" />
                                    </b-form-group>
                                    <div class="btn-container">
                                        <b-button size="lg" @click="changePassword" block class="btn-submit" variant="primary" type="button">Confirmar</b-button>
                                        <b-link href="/" class="link-voltar"> Voltar </b-link>
                                    </div>
                                </div>
                            </b-form-row>
                </b-form>
                <div class="forca-senha-content" v-show="form.password.length">
                    <span>Força de senha:</span>
                    <ul>
                        <li :class="{ checked: minuscula }">- Conter ao menos 1 letra minúscula</li>
                        <li :class="{ checked: maiuscula }">- Conter ao menos 1 letra maiúscula</li>
                        <li :class="{ checked: numero }">- Conter ao menos 1 número</li>
                        <li :class="{ checked: especial }">- Conter ao menos 1 caracter especial: <i>"! @@ # $ % & * ."</i></li>
                        <li :class="{ checked: tamanho }">- Conter entre 8 a 16 caracteres</li>
                    </ul>
                </div>
                           
  </div>
</b-container>
</template>
<script>
import router from '@/router.js'
import { Loading } from 'element-ui'
export default {
    name: 'login',
    data(){
        return {
            form: {
                password: '',
                passwordConfirmation:''
            },
            passwordForgotten: false,
            loginShow: true,
            token: ''
        }
    },
    computed: {
		user: {
            get() {
                return this.$store.state.user;
            },
            set(value) {
                this.$store.commit('updateUser', value);
            }
        },
        minuscula() {
            return /[a-z]/.test(this.form.password)
        },
        maiuscula() {
            return /[A-Z]/.test(this.form.password)
        },
        numero() {
            return /[0-9]/.test(this.form.password)
        },
        especial() {
            return /[!@#$%&*]/.test(this.form.password)
        },
        tamanho() {
            return this.form.password && this.form.password.length >= 8 && this.form.password.length <= 16
        },
	},
    methods: {
        login(ev){
            ev.preventDefault()
            
            const self = this
            const clearValues = () => {
                //self.form.Email = null
                self.form.Password = null
            }

            let loadingInstance = Loading.service(Loading);

            this.axios.post(this.$urls.LOGIN,this.form).then((res) => { // request OK
                loadingInstance.close()

                if(res.status == 200){
                    localStorage.setItem('user',JSON.stringify({ customer: res.data.customer, user: res.data.user }))
                    localStorage.setItem('accessToken',res.data.accessToken)
                    router.push({ path: '/', name: 'secure' })

                    var getUser = JSON.parse(localStorage.getItem('user')) || ''

                    this.user = res.data.user;

                    self.$notify({
                        title: 'Seja Bem vindo !',
                        message: `${getUser.user.nome} 😃`,
                        position: 'bottom-right',
                        customClass: 'bg-dark'
                    });
                }else{
                    clearValues()
                }
            }).catch(function () { // Erro de request
                loadingInstance.close()
                clearValues()
            })
            return false
        },
        forgottenPassword(){
            this.passwordForgotten = true;
            this.loginShow = false;
        },
        forgottenPasswordClose(){
            this.passwordForgotten = false;
            this.loginShow = true;
        },
        async changePassword(){
            const regexPassword = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&.*]).{8,16}$/);

           const { password, passwordConfirmation } = this.form;
           if(!password || !passwordConfirmation){
               this.handleValidation('emptyInput');
               return;
           }
           if(password !== passwordConfirmation){
               this.handleValidation('noMatch');
               return;
           }

          if(regexPassword.test(password)){
            const payLoad = {password, token: this.token, email: 'meuEmail@mail.com'};
            
            try {
                await  this.axios.post(this.$urls.FORGOT_PASSWORD, payLoad);
                  this.$notify({
                        title: 'Sucesso',
                        message: `Senha alterada com sucesso!`,
                        position:'top-left'
                 });
            } catch (error) {
                 this.$notify({
                        title: 'Ocorreu um erro no processo',
                        message: `Houve um erro ao alterar sua senha`,
                        position:'top-left'
                 });
            }finally{
                setTimeout(() => {
                  this.$router.push({ name: 'public' });  
                }, 2000);
            }
            
            
          }else{
              this.handleValidation('weekPassword');
              return;
          }
        },
        handleValidation(action){
            const err = {
                noMatch: () => {
                    this.$notify({
                        title: 'Campo senha',
                        message: `As senhas digitadas não coincidem`,
                        position:'top-left'
                    });
                },
                emptyInput: () => {
                    this.$notify({
                        title: 'Campo senha',
                        message: `Por favor, preencha todos os campos`,
                        position:'top-left'
                    });
                },
                weekPassword: () => {

                     this.$notify({
                        title: 'Campo senha',
                        message: `A senha deve atender aos requisitos de complexidade`,
                        position:'top-left'
                    });
                }
            }
            err[action]();
        }
    },
    async mounted(){
      const { token } = this.$route.params;
      if(token){
          try {
              await this.axios.get(`${this.$urls.TOKEN}?token=${token}`);
              this.token = token; 
          } catch (error) {
              this.$router.push({ name: 'public' });
          }
      }
    }
}
</script>
<style lang="scss" scoped>
.password-reset-container{
    background: #fff;
    padding: 40px;
    width: 600px;
    position: absolute;
    left: 20%;
    top: 120px;
    border-radius: 7px;
    padding-bottom: 70px;
    img{
        width: 200px;
        margin: 10px auto;
        display: block;
    }
}
.btn-container{
    display: flex;
    flex-direction: column;
    gap: 8px;
    text-align: center;
}
.info-new-password{
font-size: 12px;
text-align: center;
color: #012f3d;
line-height: 120%;
font-weight: bold;
max-width: 50%;
}
.forca-senha-content{
font-size: 12px;
font-weight: bold;
margin-left: 48px;
span{
  font-size: 13px;  
}
}

.form-login{
    input, button{
        width: 100%;
    }
    label {
        color: #797979;
    }
    ::placeholder {
        color: #c7c6c6;
        font-size: 0.8em;
    }
    .btn-submit{
        width: 100%;
        background: #608db7 !important;
        border-color: #608db7 !important;
        &:hover{
            background: #5583af !important;
        }
    }
}
li.checked {
    color: #0fa41a;
    position:relative;
}
li.checked:after {
    content: '✓';
    position:absolute;
    margin-left: 10px;
}

@media (max-width: 600px){
  .desconectar-reset-container{
    left: 0%;
  }
}
</style>
